export class Access {
  userId: string;
  resourceId: string;
  resourceType: string;
  accessLevel: string;

  constructor(userId: string, resourceId: string, resourceType: string, accessLevel: string) {
    this.userId = userId;
    this.resourceId = resourceId;
    this.resourceType = resourceType;
    this.accessLevel = accessLevel;
  }
}
